<p>{{ text | translate }}</p>
